import styled from '@emotion/styled'
import { BREAKPOINTS } from 'utils/styled'

export const SPartnerBenefits = styled.div`
  display: flex;
  @media ${BREAKPOINTS.MD.max} {
    flex-direction: column;
    margin-right: calc(-5% * (100 / 90));
  }
`

export const SLeftDiv = styled.div`
  flex-basis: 50%;
  flex-shrink: 1;
`

export const SRightDiv = styled.div`
  flex-basis: 50%;
  display: flex;
  align-items: center;
  margin-left: 5.4375rem;
  position: relative;
  margin-right: var(--p-content);
  margin-right: 5%;

  @media ${BREAKPOINTS.MD.max} {
    margin-left: 0;
  }
`

export const SLeftContent = styled.div`
  position: relative;
  padding: 43px 0;
  margin-top: 2rem;
  margin-bottom: 7.5rem;

  &:before {
    content: '';
    border: 2px solid var(--c-blue100);
    position: absolute;
    z-index: -1;
    top: 0;
    left: var(--p-button);
    right: -19px;
    bottom: 0;
  }

  @media ${BREAKPOINTS.MD.max} {
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 0;

    &:before {
      top: -5rem;
      bottom: 40%;
    }
  }
`
